import { useCompany } from 'modules/app/hooks/useCompany';

import { getBankInfoFieldsCombo } from './bankInfoFormats';

export const useBankInfoFieldsCombo = () => {
  const company = useCompany();
  return (bankCountry: string | null) =>
    getBankInfoFieldsCombo(company.country, bankCountry, company.currency);
};
